module.exports = __webpack_public_path__ + "static/img/mall_rank_popup_title_img2.301fbf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_rank_popup_title_img2.png
// module id = 1hoV
// module chunks = 0